// Model i tipus per a la configuració avançada de tests i rúbrica de puntuació (0-100) en exercicis de Disseny (ER, Script, Relacional)

export interface RubricItem {
    id: string;                      // Identificador únic del criteri (ex: "entity_EQUIP", "attr_EQUIP.nom", "conn_c1")
    category: 'entity' | 'relationship' | 'attribute' | 'connection' | 'hierarchy' | 'table' | 'column' | 'pk' | 'fk';
    label: string;                   // Nom descriptiu (ex: 'Entitat "EQUIPO"', 'Atribut PK "id"', 'FK "equip_id -> EQUIP"')
    details?: string;                // Informació addicional (ex: "Cardinalitat 1:N", "Participació (1,1)", "Tipus VARCHAR(50)")
    enabled: boolean;                // Si s'avalua o s'ignora
    points: number;                  // Punts assignats (la suma dels enabled ha de ser 100)
    targetKey?: string;              // Clau interna per associar amb els elements de la solució
}

export interface DesignTestsConfig {
    version: number;
    penalitzacioPerIntent?: number;  // Punts a restar per cada intent fallit previ (0 per defecte)
    items: RubricItem[];             // Llistat d'ítems avaluables
}

export const createDefaultDesignTestsConfig = (initialPenalitzacio = 0): DesignTestsConfig => ({
    version: 1,
    penalitzacioPerIntent: initialPenalitzacio,
    items: []
});
